module.exports = __webpack_public_path__ + "img/qr-code-guizhou.0ce9583c.jpg";